import React, { useRef } from "react";
import { Box, Button } from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import moment from "moment";
import { downloadExcel } from "react-export-table-to-excel";

const headerCellStyle = {
  backgroundColor: "#1f5f8b",
  color: "#ffffff",
  fontWeight: "bold",
  padding: "10px",
  textAlign: "left",
  border: "1px solid #d5dee5",
};

const bodyCellStyle = {
  padding: "8px 10px",
  border: "1px solid #d5dee5",
  verticalAlign: "top",
};

const ParticipantExcelExport = ({ data = [], eventName }) => {
  const tableRef = useRef(null);
  const title = eventName?.trim() || "Event Participants";
  const filename = title.replace(/[<>:"/\\|?*]+/g, "-").trim();

  const handleDownload = () => {
    downloadExcel(
      {
        fileName: `${filename || "Event Participants"}.xls`,
        sheet: "Participants",
      },
      tableRef.current,
    );
  };

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        startIcon={<FileDownloadOutlinedIcon />}
        onClick={handleDownload}
        disabled={!data.length}
      >
        Download Excel
      </Button>
      <Box
        aria-hidden="true"
        sx={{ position: "fixed", left: "-10000px", top: 0 }}
      >
        <table
          ref={tableRef}
          style={{
            borderCollapse: "collapse",
            fontFamily: "Arial, sans-serif",
            fontSize: "12px",
            width: "100%",
          }}
        >
          <thead>
            <tr>
              <th
                colSpan={5}
                style={{
                  backgroundColor: "#163f5c",
                  color: "#ffffff",
                  fontSize: "18px",
                  padding: "14px 10px",
                  textAlign: "center",
                }}
              >
                {title}
              </th>
            </tr>
            <tr>
              {["Name", "Batch", "Joined At", "Joined As"].map((label) => (
                <th key={label} style={headerCellStyle}>
                  {label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((participant, index) => (
              <tr key={participant?.id || participant?.userId || index}>
                <td style={bodyCellStyle}>
                  {participant?.alumniMemberMini?.name || "N/A"}
                </td>

                <td style={bodyCellStyle}>
                  {participant?.alumniMemberMini?.batchTag || "N/A"}
                </td>
                <td style={bodyCellStyle}>
                  {participant?.appliedDateTime
                    ? moment(participant.appliedDateTime).format(
                        "DD/MM/YYYY h:mm A",
                      )
                    : "N/A"}
                </td>
                <td style={bodyCellStyle}>
                  {participant?.volunteers ? "Volunteer" : "Participant"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
    </>
  );
};

export default ParticipantExcelExport;
